import React, { useEffect, useState } from 'react';
import '../UI/TestEntrymodal.css';
import { GetDataBySearch, Get_AgeGroup } from '../Services/TestServices';
import SpinnerModal from '../Spinner/SpinnerModal';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { useApi } from '../ContextApi/ContextApi';
import { Divider } from '@mui/material';
import { Button } from '@mui/material';
import { toast } from 'react-toastify';
import CancelIcon from '@mui/icons-material/Cancel';
import '../UI/LabOrder.css';

const LabOrder = React.memo(({ onSubmit , patientName }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [AgegroupData, SetAgegroupData] = useState([]);

  const [searchData, setSearchData] = useState([]);
  const [selectedTests, setSelectedTests] = useState([]);
  const [totalprice, setTotalPrice] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [DiscountAmmount, setDiscountAmmount] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [ReceivedAmount, SetReceivedAmount] = useState(0);
  const [DueAmount, SetDueAmount] = useState(0);

  const [isReset, setIsReset] = useState(false);
  const [showPrintModal, setShowPrintModal] = useState(false); // Modal control state
  const [discountType, setDiscountType] = useState("percentage"); // percentage | amount
  const [Params, setParams] = useState({
    SearchParam: '',
    GenderCategory: '',
    AGE_CODE: '',
    LabID: sessionStorage.getItem('LabID'),
  });

  const onChange = (e) => {
    const { name, value } = e.target;
    setParams({
      ...Params,
      [name]: value,
    });
  };

  // Reset State after submitting form Successfully
  useEffect(() => {
    if (isReset) {
      setParams({
        SearchParams: '',
        GenderCategory: '',
        AGE_CODE: '',
        LabID: sessionStorage.getItem('LabID'),
      });
      Setfinaldataset([]);
      setSelectedTests([]);
      setTotalPrice(0);
      setDiscount(0);
      setGrandTotal(0);
      SetReceivedAmount(0);
      SetDueAmount(0);
      setIsReset(false);
    }
  }, [isReset]);

  // Search test
  const getTestsList = async (e) => {
    setIsLoading(true);
    try {
      const response = await GetDataBySearch(Params);
      setSearchData(response);
    } catch (error) {
      console.log('Error while searching test', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getTestsList();
  }, []);

  // Select and Add test
  const addToSelectedTests = (testItem) => {
    const isTestSelected = selectedTests.some((selectedTest) => selectedTest.testID === testItem.testID);
    if (isTestSelected) {
      toast.warning('Test Already selected');
    } else {
      setSelectedTests([...selectedTests, { ...testItem, quantity: 1 }]);
    }
  };

  // Remove test from selected test
  const removeTest = (id) => {
    const updatedList = selectedTests.filter((x) => x.testID !== id);
    setSelectedTests(updatedList);
  };

  // Reset the list
  const ResetSearchList = () => {
    Setfinaldataset([]);
    setSearchTerm("");
  };

  // Price Calculation
  useEffect(() => {
    calculateTotalPrice();
  }, [selectedTests, discount, discountType, ReceivedAmount]);

  // const calculateTotalPrice = () => {
  //   const total = selectedTests.reduce((prev, current) => {
  //     const price = parseFloat(current.testPrice);
  //     return !isNaN(price) ? prev + price : prev;
  //   }, 0);
  //   setTotalPrice(total);
  //   const discountAmount = (total * discount) / 100;
  //   const finalGrandTotal = total - discountAmount;
  //   setGrandTotal(finalGrandTotal);
  //   setDiscountAmmount(discountAmount);
  //   SetDueAmount(finalGrandTotal - parseFloat(ReceivedAmount || 0));
  // };

  const calculateTotalPrice = () => {
    const total = selectedTests.reduce((sum, item) => {
        return sum + (parseFloat(item.testPrice) || 0);
    }, 0);

    setTotalPrice(total);

    let discountAmount = 0;

    if (discountType === "percentage") {
        discountAmount = (total * discount) / 100;
    } else {
        discountAmount = parseFloat(discount) || 0;

        // Prevent discount greater than total
        if (discountAmount > total) {
            discountAmount = total;
        }
    }

    const finalGrandTotal = total - discountAmount;

    setDiscountAmmount(discountAmount);
    setGrandTotal(finalGrandTotal);
    SetDueAmount(finalGrandTotal - (parseFloat(ReceivedAmount) || 0));
};
  const handleChangedDiscount = (e) => {
    const value = parseFloat(e.target.value) || 0;
    setDiscount(value);
  };

  // CRITICAL FIX: Safe state updates back to parent layout wrapped in useEffect
  useEffect(() => {
    const formattedTests = selectedTests.map((testItem) => ({
      TestID: testItem.testID,
      LaboratoryID: sessionStorage.getItem('LabID'),
      Created_at: new Date(),
      CreatedBy: sessionStorage.getItem('UserID'),
      UpdatedBy: sessionStorage.getItem('UserID'),
      TotalBill: totalprice,
      Discount: DiscountAmmount,
      GrandTotal: grandTotal,
      ReceivedAmount: ReceivedAmount,
      DueAmount: DueAmount,
    }));

    if (onSubmit) {
      onSubmit(formattedTests);
    }
  }, [selectedTests, totalprice, DiscountAmmount, grandTotal, ReceivedAmount, DueAmount, onSubmit]);

  const DiscountOptions = [
    { value: 0, label: '0%' }, { value: 5, label: '5%' }, { value: 10, label: '10%' },
    { value: 15, label: '15%' }, { value: 20, label: '20%' }, { value: 25, label: '25%' },
    { value: 30, label: '30%' }, { value: 35, label: '35%' }, { value: 40, label: '45%' },
    { value: 50, label: '50%' }, { value: 55, label: '55%' }, { value: 60, label: '60%' },
    { value: 65, label: '65%' }, { value: 70, label: '70%' }, { value: 75, label: '75%' },
    { value: 80, label: '80%' }, { value: 85, label: '85%' }, { value: 90, label: '90%' },
    { value: 95, label: '95%' }, { value: 100, label: '100%' }
  ];

  // Server side search function
  const [searchTerm, setSearchTerm] = useState("");
  const [finaldataset, Setfinaldataset] = useState([]);

  const OnSearchChange = (e) => {
    const currentVal = e.target.value;
    setSearchTerm(currentVal);
    
    if (!currentVal.trim()) {
      Setfinaldataset([]);
      return;
    }

    const filteredData = searchData.filter((testItem) => {
      return (
        (testItem.testName && testItem.testName.toLowerCase().includes(currentVal.toLowerCase())) ||
        (testItem.categorY_VALUE && testItem.categorY_VALUE.toLowerCase().includes(currentVal.toLowerCase())) ||
        (testItem.suB_CATEGORY_VALUE && testItem.suB_CATEGORY_VALUE.toLowerCase().includes(currentVal.toLowerCase()))
      );
    });
    Setfinaldataset(filteredData);
  };

  const GetAgeGroup = async () => {
    try {
      const response = await Get_AgeGroup(sessionStorage.getItem('LabID'));
      SetAgegroupData(response);
    } catch (error) {
      console.error("Error fetching settings:", error);
    }
  };

  useEffect(() => {
    GetAgeGroup();
  }, []);

  // Select All test from search list
  const SelectAllTest = (e) => {
    e.preventDefault();
    if (finaldataset.length > 0) {
      const updatedSelectedTests = [...selectedTests];
      finaldataset.forEach(testItem => {
        const alreadyExists = updatedSelectedTests.some(t => t.testID === testItem.testID);
        if (!alreadyExists) {
          updatedSelectedTests.push({ ...testItem, quantity: 1 });
        }
      });
      setSelectedTests(updatedSelectedTests);
      toast.info('All tests have been added to the selected list');
    } else {
      toast.error('No tests available to select');
    }
  };

  // Received and Due amount
  const onReceivedAmount = (e) => {
    const value = parseFloat(e.target.value) || 0;
    SetReceivedAmount(value);
    SetDueAmount(grandTotal - value);
  };

  const handleDirectPrint = () => {
  // 1. Grab only the inner HTML structure of the receipt layout
  const receiptHTML = document.querySelector('.popup-receipt-content').innerHTML;
  
  // 2. Open an isolated, blank browser window target
  const printWindow = window.open('', '_blank', 'width=600,height=600');
  
  // 3. Write standard document structures + your exact styling into the isolated target
  printWindow.document.write(`
    <html>
      <head>
        <title>Receipt Print</title>
        <style>
          body {
            margin: 0;
            padding: 2mm;
            width: 58mm;
            font-family: 'Courier New', Courier, monospace;
            font-size: 11px;
            color: #000;
            line-height: 1.4;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            font-size: 11px;
          }
          /* Re-apply any explicit visual utilities used inside your popup component */
          div { word-break: break-word; }
        </style>
      </head>
      <body>
        ${receiptHTML}
      </body>
    </html>
  `);
  
  // 4. Close the document string execution loop, focus, and prompt the system printer immediately
  printWindow.document.close();
  printWindow.focus();
  
  // A small delay ensures the content is fully loaded into the new window before execution
  setTimeout(() => {
    printWindow.print();
    printWindow.close(); // Automatically dismisses the blank window element when finished/canceled
  }, 250);
};
  return (
    <>
     

      {isLoading && <SpinnerModal isLoading={true} />}
      <div className="container-fluid">
        <form className='child-container' onSubmit={(e) => e.preventDefault()}>
          <div className="row justify-content-between ">
            <div className="col-sm-5 search-Test-dev">
              <div className='common-FontFamily common-FontSize-small '>
                <div className='Parent-search-div'>
                  <div className='search-div'>
                    <input
                      name='SearchParam'
                      placeholder='Search Test'
                      className='search-input common-Input'
                      onChange={OnSearchChange}
                      value={searchTerm}
                    />
                    <button type='button' className='clear-button' onClick={ResetSearchList}>
                      <CancelIcon className='clear-cross' />
                    </button>
                  </div>
                </div>

                <ul className="search_List common-FontSize-small common-FontFamily common-FontWeight">
                  <li>
                    <button type="button" onClick={SelectAllTest} className='select-All-search-list common-FontSize-small common-FontFamily common-FontWeight'>Select All</button>
                  </li>
                  {finaldataset && finaldataset.length > 0 ? finaldataset.map((testItem) => (
                    <li key={testItem.testID} onClick={() => addToSelectedTests(testItem)}>
                      <span style={{ display: 'inline-block', minWidth: '50%' }}> {testItem.testName}</span> <span>{testItem.categorY_VALUE}</span>
                    </li>
                  )) : <p style={{ color: 'red', textAlign: 'center' }} className='common-FontFamily common-FontSize-small'>No Record Found</p>}
                </ul>
              </div>
            </div>

            <div className="col-sm-5 TestList-dev common-FontSize-small common-FontFamily common-FontWeight">
              <div className="col-sm-12">
                <div>
                  <table className="w-100">
                    <thead>
                      <tr>
                        <th className='Table-Th common-text-start common-FontSize-small common-FontFamily common-FontWeight'>Test</th>
                        <th className='Table-Th common-text-start common-FontSize-small common-FontFamily common-FontWeight'>Price</th>
                        <th className='Table-Th common-text-start common-FontSize-small common-FontFamily common-FontWeight'>Category</th>
                        <th className='Table-Th common-text-start common-FontSize-small common-FontFamily common-FontWeight'>Remove</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedTests.map((testItem) => (
                        <tr className='striped-row' key={testItem.testID}>
                          <td className='table-td'>{testItem.testName}</td>
                          <td className='table-td'>{testItem.testPrice}</td>
                          <td className='table-td'>{testItem.categorY_VALUE}</td>
                          <td className='table-td'>
                            <CloseRoundedIcon className="Cross" onClick={() => removeTest(testItem.testID)} />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="col-sm-2 common-FontSize-small common-FontFamily common-FontWeight Financial-dev">
              <div className='finance-section-heading'>
                <span>Discount and Total</span>
              </div>
              <div className='d-flex justify-content-between p-2'>
                <div style={{ gap: '3px' }} className='d-flex flex-column align-items-start'>
                  <label className='finance-item'>Total Price:</label>
                  <label className='finance-item'>Discount:</label>
                  <label className='finance-item'>Grand Total:</label>
                  <label className='finance-item'> Paid:</label>
                  <label className='finance-item'> Due Amount:</label>
                </div>
                <div className='d-flex flex-column align-items-end p-2'>
                  <span className='finance-item f-item-border' style={{ background: 'lightgray' }}>
                    {totalprice}
                  </span>
                                  {/* <span className='finance-item f-item-border'>
                                    <select className='DiscountDropdown common-FontSize-small common-FontFamily common-FontWeight' name='Discount' onChange={handleChangedDiscount} value={discount}>
                                      {DiscountOptions.map((option) => (
                                        <option key={option.value} value={option.value}>
                                          {option.label}
                                        </option>
                                      ))}
                                    </select>
                                  </span> */}
                                  <div className="d-flex gap-2">

    <select
        value={discountType}
        onChange={(e) => {
            setDiscountType(e.target.value);
            setDiscount(0);
        }}
    >
        <option value="percentage">%</option>
        <option value="amount">Rs</option>
    </select>

    {
        discountType === "percentage" ? (
            <span className='finance-item f-item-border'>
                                    <select className='DiscountDropdown common-FontSize-small common-FontFamily common-FontWeight' name='Discount' onChange={handleChangedDiscount} value={discount}>
                                      {DiscountOptions.map((option) => (
                                        <option key={option.value} value={option.value}>
                                          {option.label}
                                        </option>
                                      ))}
                                    </select>
                                  </span>
        ) : (
          <span className='finance-item f-item-border'>

          
            <input
                type="number"
                placeholder="Discount Amount"
                value={discount}
                className='ReceivedAmmount common-FontSize-small common-FontFamily common-FontWeight'
                onChange={(e) => setDiscount(parseFloat(e.target.value) || 0)}
            />
        </span>
        )
    }

</div>

                  <span className='finance-item f-item-border' style={{ background: 'lightgray' }}>
                    {grandTotal}
                  </span>
                  <span className='finance-item f-item-border'>
                    <input type="number" className='ReceivedAmmount common-FontSize-small common-FontFamily common-FontWeight' onChange={onReceivedAmount} value={ReceivedAmount} />
                  </span>
                  <span className='finance-item f-item-border' style={{ background: 'lightgray' }}>
                    {DueAmount}
                  </span>
                </div>
              </div>
              
              {/* Added View Receipt Modal Trigger Button Here */}
              <div className="p-2 w-100">
                <Button  
                  onClick={() => setShowPrintModal(true)}  
                  type='button'   
                  variant="contained" 
                  className="common-button mt-3" 
                  style={{float:'inline-end'}}> 
                  View Receipt
               </Button>
                             
              </div>
            </div>
          </div>
        </form>
      </div>

      {/* POPUP PREVIEW OVERLAY */}
      {showPrintModal && (
        <div className="custom-print-overlay">
          <div className="custom-print-popup">
            
            {/* Scrollable Receipt Component wrapped in 58mm dimension styling */}
            <div className="popup-receipt-content">
              <div style={{ borderBottom: '1px solid #000', paddingBottom: '4px', marginBottom: '6px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span>LAB Name:</span>
                  <span>{sessionStorage.getItem('FirstName') || 'N/A'}{sessionStorage.getItem('LastName') || 'N/A'}</span>
                </div>
                {/* ADDED: Patient Name Field */}
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span>PATIENT:</span>
                  <span style={{ fontWeight: 'bold' }}>{(patientName || 'N/A').toUpperCase()}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span>DATE:</span>
                  <span>{new Date().toLocaleDateString()}</span>
                </div>
              </div>

              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '11px' }}>
                <thead>
                  <tr style={{ borderBottom: '1.5px solid #000', textAlign: 'left' }}>
                    <th style={{ width: '55%' }}>Services</th>
                    <th style={{ textAlign: 'right', width: '20%' }}>Rate</th>
                    <th style={{ textAlign: 'center', width: '10%' }}>Qty</th>
                    <th style={{ textAlign: 'right', width: '15%' }}>AMT</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedTests.map((test, index) => {
                    const priceVal = parseFloat(test.testPrice) || 0;
                    return (
                      <tr key={test.testID || index} style={{ verticalAlign: 'top' }}>
                        <td style={{ padding: '4px 0', wordBreak: 'break-word' }}>{(test.testName || 'TEST').toUpperCase()}</td>
                        <td style={{ padding: '4px 0', textAlign: 'right' }}>{priceVal}</td>
                        <td style={{ padding: '4px 0', textAlign: 'center' }}>1</td>
                        <td style={{ padding: '4px 0', textAlign: 'right' }}>{priceVal}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>

              <div style={{ marginTop: '4px', borderTop: '1px solid #000', paddingTop: '4px' }}>
                <div style={{ display: 'flex', justifyContent: 'flex-end', fontWeight: 'bold' }}>
                  <span style={{ width: '40%', textAlign: 'left' }}>Total</span>
                  <span style={{ width: '30%', textAlign: 'right' }}>{totalprice}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <span style={{ width: '40%', textAlign: 'left' }}>Paid</span>
                  <span style={{ width: '30%', textAlign: 'right' }}>{ReceivedAmount || 0}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', borderTop: '1px dashed #000', marginTop: '2px', paddingTop: '2px' }}>
                  <span style={{ width: '40%', textAlign: 'left' }}>Balance</span>
                  <span style={{ width: '30%', textAlign: 'right' }}>{DueAmount}</span>
                </div>
              </div>

              <div style={{ marginTop: '15px', fontSize: '9px', textAlign: 'left', borderTop: '1px solid #000', paddingTop: '5px' }}>
                <div>* This is a computer generated receipt.</div>
                <div>* Please bring this receipt for collection of reports.</div>
              </div>
            </div>

            {/* Popup Interaction Toolbar */}
            <div className="popup-action-row">
             <button 
              type="button" 
              className="btn btn-success w-50 common-FontFamily common-FontSize-small" 
              onClick={handleDirectPrint}
            >
              Print
            </button>
              <button 
                type="button" 
                className="btn btn-danger w-50 common-FontFamily common-FontSize-small" 
                onClick={() => setShowPrintModal(false)}
              >
                Close
              </button>
            </div>

          </div>
        </div>
      )}
    </>
  );
});

export default LabOrder;